export default "__VITE_ASSET__d6c97093__"